import React, { useRef, useState, forwardRef, useEffect, useCallback } from 'react';
import {
  Dialog, Slide, IconButton, Box, Typography,
  DialogActions, DialogContent, Button,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Close, Download } from '@mui/icons-material';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import { DOMAIN, R2DOMAIN } from '../../config';
import LoginRegisterDialog from '../appDialog/login';
import VideoInfoPanel from './videoInfoPanel';
import VideoPlayerArea from './videoPlayerArea';
import VideoKeyword from './videoKeyword';
import VideoGallery from './videoGallery';
import MembershipPricing from '../appDialog/membershipPricing';
import SearchDialog from '../appDialog';
import { useUser } from "../../contexts/userContext";
import AppInfo from "../common/appInfo";
import { useMediaQuery} from "@mui/material";
import theme from '../../styles/theme'


const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function VideoPlayerDialog({ handleChangeVideoid, open, onClose, videoid, title = '', thumbnail, player }) {
  const playerRef = useRef(null);
  const { userData } = useUser();
  const matches = useMediaQuery(theme.breakpoints.down("md"))

  const [state, setState] = useState({
    playing: false,
    showVipDialog: false,
    url: '',
    vip: false,
    openLogin: false,
    isUser: false,
    vid: 0,
    views: 0,
    likes: 0,
    favorites: 0,
    caption: '',
    date: 0,
    openSearch: false,
    chipTitle: null,
    commentsTotal: 0,
    firstComments: '',
    blogger: null,
    videoGalleryKey: videoid,
    showMembership: false,
    openDownload: false,
    appInfoOpen: false,
    appInfoMessage: "收藏视频成功！左上角“菜单->我的收藏”"
  });

  const updateState = (patch) => setState(prev => ({ ...prev, ...patch }));


  const handlePayVip = () => {
  try {
    const tel_user = window?.Telegram?.WebApp?.initDataUnsafe;
    const isInMiniApp = tel_user && Object.keys(tel_user).length > 0;

    if (isInMiniApp && window?.Telegram?.WebApp?.openTelegramLink) {
      // ✅ 在小程序内，直接跳转到机器人
      window.Telegram.WebApp.openTelegramLink("https://t.me/yqkcbot?start=1");
      return;
    }

    // ✅ 非小程序环境，显示会员开通弹窗
    updateState({ showMembership: true, showVipDialog: false });
  } catch (error) {
    console.error("handlePayVip error:", error);
    // 兜底逻辑
    updateState({ showMembership: true, showVipDialog: false });
  }
};


  // 加载视频数据
  const loadVideoData = useCallback(async () => {
    if (!videoid) return;
    const initData = window.Telegram?.WebApp?.initDataUnsafe;
    const isTelegram = initData && Object.keys(initData).length > 0;
    const playerApi = isTelegram
      ? `${DOMAIN}player/getPlayerForTelegram?videoid=${videoid}&userid=${initData.user?.id}`
      : `${DOMAIN}player/getPlayer?videoid=${videoid}`;

    const res = await fetch(playerApi, { credentials: 'include' });
    const data = await res.json();

    const bloggerMatch = data.caption?.match(/原创：#(\S+)/) || data.caption?.match(/类型：#(\S+)/);
    const keywordMatch = data.caption?.match(/类型：#(\S+)/);
    const keyword2 = keywordMatch[1]
    console.log(data)
    updateState({
      date: data.date,
      caption: data.caption,
      vip: data.isvip,
      isUser: !!data.user,
      url: data.isvip && data.r2 ? `${R2DOMAIN}${data.r2}` : '',
      views: data.views || 0,
      likes: data.likes || 0,
      favorites: data.favorites || 0,
      blogger: bloggerMatch?.[1] || null,
      keyword2:keyword2,
      vid: videoid,
      videoGalleryKey: videoid
    });
  }, [videoid]);

  

  useEffect(() => {
    if (open) {
      
      updateState({ playing: false, showVipDialog: false });
      loadVideoData()
    } else {
      updateState({ videoGalleryKey: videoid }); // 关闭时更新gallery key
    }
  }, [open, videoid, loadVideoData]);

  // 收藏视频
  const handleSave = async () => {
    const tel_user = window.Telegram?.WebApp?.initDataUnsafe;
    
    let url = '';
    if(userData) url = `${DOMAIN}ywyminiappbot/addFavorWeb?username=${userData.username}&vid=${videoid}&cookieid=${userData.cookie}`;
    if (tel_user && Object.keys(tel_user).length > 0) {
      url = `${DOMAIN}ywyminiappbot/addFavor?userid=${tel_user.user.id}&vid=${videoid}`;
    }

    if(!url) return updateState({ openLogin: true });

    const res = await fetch(url, { credentials: 'include' });
    await res.json();
    updateState({ appInfoMessage: "收藏成功", appInfoOpen: true });
  };

  // 下载视频
  const handleDownload = () => {
    const tel_user = window.Telegram?.WebApp?.initDataUnsafe;
    let isLogin = 0;

    if(userData) isLogin = 1;
    if(userData?.isvip) isLogin = 2;
    if(tel_user && Object.keys(tel_user).length > 0) {
      isLogin = 1;
      if(state.vip) {
        isLogin = 2;
        const downloadUrl = `${player}?start=dl_${videoid}`;
        window.Telegram.WebApp.openTelegramLink(downloadUrl);
      }
    }

    if(isLogin === 0) updateState({ openLogin: true });
    if(isLogin === 1) updateState({ showVipDialog: true });
  };

  const handlePlayToggle = () => {
    if (!state.isUser) updateState({ openLogin: true });
    else if (state.vip) updateState({ playing: !state.playing });
    else updateState({ showVipDialog: true });
  };

  const handleLoginSuccess = async (userData = null) => {
    updateState({ vip: userData?.user?.isvip || false, isUser: true, openLogin: false });
    if (userData?.user?.isvip) {
      const res = await fetch(`${DOMAIN}player/getR2`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ vid: state.vid, username: userData.user.username, cookie: userData.user.cookie })
      });
      const d = await res.json();
      updateState({ url: `${R2DOMAIN}${d.r2}` });
    }
  };

  return (
    <>
      {/* 搜索弹窗 */}
      <SearchDialog openSearch={state.openSearch} setOpenSearch={(v)=>updateState({openSearch:v})} matches={matches} chipTitle={state.chipTitle}/>
      <LoginRegisterDialog open={state.openLogin} onClose={()=>updateState({openLogin:false})} onSuccess={handleLoginSuccess}/>
      <AppInfo message={state.appInfoMessage} vertical="bottom" setAppInfoOpen={(v)=>updateState({appInfoOpen:v})} appInfoOpen={state.appInfoOpen}/>
      <DownloadButton player={player} videoid={videoid} title={state.caption} open={state.openDownload} setOpen={(v)=>updateState({openDownload:v})}/>

      {/* 视频主 Dialog */}
      <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition} PaperProps={{ sx: { bgcolor: 'background.default', p:0 } }}>
        {/* 顶部导航 */}
        <Box sx={{position:"fixed",top:0,left:0,right:0,height:56,display:"flex",alignItems:"center",px:2,zIndex:20,background:"linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0))"}}>
          <IconButton onClick={onClose} sx={{bgcolor:"rgba(0,0,0,0.6)",color:"#fff"}}><Close/></IconButton>
          <Typography sx={{ml:2,color:"#fff",fontSize:"0.9rem",flex:1}}>{title}</Typography>
          <IconButton onClick={handleSave} sx={{bgcolor:"rgba(0,0,0,0.6)",color:"#fff",ml:1}}><BookmarkAddIcon/></IconButton>
          <IconButton onClick={handleDownload} sx={{bgcolor:"rgba(0,0,0,0.6)",color:"#fff",ml:1}}><Download/></IconButton>
        </Box>

        {/* 视频播放器区域 */}
        <Box sx={{position:"fixed",top:0,left:0,right:0,zIndex:15,bgcolor:"background.default"}}>
          {state.isUser && state.vip 
            ? <VideoPlayerArea vip={state.vip} url={state.url} thumbnail={thumbnail} playing={state.playing} onPlayToggle={handlePlayToggle} playerRef={playerRef}/>
            : <Box sx={{position:"relative",width:"100%",height:"32vh",bgcolor:"#000",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <img
                  src={`${DOMAIN}miniapp/${thumbnail}.tb.jpg`}
                  alt="video thumbnail"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  onError={(e) => {
                    e.target.onerror = null; // 防止循环触发
                    e.target.src = `${DOMAIN}miniapp/${thumbnail}.jpg`; // 加载备用图
                  }}
                />

                <IconButton onClick={handlePlayToggle} sx={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",bgcolor:"rgba(0,0,0,0.3)",color:"#fff","&:hover":{bgcolor:"rgba(0,0,0,0.8)"},borderRadius:"50%",p:1.5}}>
                  <SmartDisplayIcon sx={{fontSize:64}}/>
                </IconButton>
              </Box>
          }

          <Box sx={{px:{xs:1,sm:2,md:3},mt:0}}>
            <VideoInfoPanel
              date={state.date} title={state.caption}
              views={state.views} likes={state.likes} favorites={state.favorites}
              onLike={()=>updateState({likes:state.likes+1})}
              onFavorite={()=>updateState({favorites:state.favorites+1})}
              onShare={()=>alert("分享视频链接: "+window.location.href)}
            />
          </Box>
        </Box>

        {/* 视频信息区 */}
        <Box sx={{ mt: { xs: 'calc(56px + 37vh + 8px)', sm: 'calc(56px + 37vh + 8px)'}, px: { xs:1, sm:2, md:3 }, overflowY:'auto', pb:8 }}>
          <VideoKeyword
            caption={state.caption}
            setOpenSearch={(v)=>updateState({openSearch:v})}
            setChipTitle={(v)=>updateState({chipTitle:v})}
            onTagClick={(type,value)=>updateState({chipTitle:value, openSearch:true})}
          />
          {state.blogger && state.vid && (
            <VideoGallery
              videoid={videoid}
              key={state.videoGalleryKey}
              handleChangeVideoid={handleChangeVideoid}
              thumbnail={thumbnail}
              videos={async (page = 0, size = 5) => {
                const res = await fetch(`${DOMAIN}player/getKeywordVideos?keyword=${state.blogger}&page=${page}&size=${size}&videoid=${state.vid}&keyword2=${state.keyword2}`, {
                  headers:{'Content-Type':'application/json'},
                  credentials:'include'
                });
                return await res.json();
              }}
            />
          )}
        </Box>
      </Dialog>

     {/* VIP提示弹窗 */}
<Dialog open={state.showVipDialog} onClose={() => updateState({ showVipDialog: false })}>
  <DialogContent>
    该视频为 VIP 专属内容，请开通会员后观看完整视频。
  </DialogContent>
  <DialogActions>
    <Button onClick={() => updateState({ showVipDialog: false })}>取消</Button>
    <Button 
      variant="contained" 
      color="primary" 
      onClick={handlePayVip}   // ✅ 点击时调用统一方法
    >
      开通会员
    </Button>
  </DialogActions>
</Dialog>

{/* 会员开通弹窗 */}
{state.showMembership && (
  <MembershipPricing 
    open={state.showMembership} 
    onClose={() => updateState({ showMembership: false })} 
  />
)}

    </>
  );
}

// 下载按钮组件
const DownloadButton = ({ player, videoid, title, open, setOpen }) => {
  const fullUrl = `https://t.me/ywyntr1bot/app`;

  return (
    <Dialog open={open} onClose={()=>setOpen(false)}>
      <DialogTitle>下载提示</DialogTitle>
      <DialogContent>
        <DialogContentText>
          目前夜未央仅支持使用电报小程序进行下载，如果您还没有电报（Telegram）请点击电报官网前往下载安装，如您已经有电报，请点击打开小程序。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>setOpen(false)}>取消</Button>
        <Button onClick={()=>window.open("https://telegram.org/", "_blank")}>电报官网</Button>
        <Button onClick={()=>window.open(fullUrl, "_blank")}>打开小程序进行下载</Button>
      </DialogActions>
    </Dialog>
  );
};
